/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import YouTube from 'react-youtube';

class Youtube extends React.Component {
    render() {
        if (this.msiVersion() == null)
            return <YouTube {...this.props}/>;
        return null;
    }

    msiVersion() {
        let ua = window.navigator.userAgent;
        let msie = ua.indexOf("MSIE ");
        if (msie > 0) {// If Internet Explorer, return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
        }
    }
}

export default Youtube;